var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrofeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 101.46,
    height: 101.46,
    viewBox: "0 0 101.46 101.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb03b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#fbb03b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8a43a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_602",
    "data-name": "Grupo 602",
    transform: "translate(-22.825 -13.706)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(22.825 13.706)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_004---Trophy",
    "data-name": "004---Trophy",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path",
    transform: "translate(18.509 8.455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3152",
    "data-name": "Trazado 3152",
    d: "M169.968,52.569v33.82a32.085,32.085,0,0,1-5.259,17.62h-.017a32.12,32.12,0,0,1-53.706,0h-.017a32.087,32.087,0,0,1-5.259-17.62V52.569Z",
    transform: "translate(-105.71 -52.569)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3153",
    "data-name": "Trazado 3153",
    d: "M190.282,65.612c-8.18,1.4-30.824,7.394-50.821,32.214l14.335,2.828s-13.951,6.2-22.131,16.74c.693,1.093,1.406,2.185,2.184,3.223a141.717,141.717,0,0,1,50.867-22.683,57.05,57.05,0,0,0-16.507-4.369s7.115-6.059,22.072-9.07Z",
    transform: "translate(-125.869 -62.699)",
    fill: "#fcd08c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-2",
    "data-name": "Path",
    transform: "translate(48.101 8.455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3154",
    "data-name": "Trazado 3154",
    d: "M267.822,52.569v33.82a32.085,32.085,0,0,1-5.259,17.62h-.017a31.978,31.978,0,0,1-24.316,14.4c.845.067,1.681.113,2.537.113a32.16,32.16,0,0,0,26.853-14.509h.017a32.085,32.085,0,0,0,5.259-17.62V52.569Z",
    transform: "translate(-238.229 -52.569)",
    fill: "#fcd08c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(15.127 1.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3155",
    "data-name": "Trazado 3155",
    d: "M93.947,22.279H158.2a3.382,3.382,0,0,1,3.382,3.382h0a3.382,3.382,0,0,1-3.382,3.382H93.947a3.382,3.382,0,0,1-3.382-3.382h0A3.382,3.382,0,0,1,93.947,22.279Z",
    transform: "translate(-90.565 -22.279)",
    fill: "#fcd08c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-3",
    "data-name": "Path",
    transform: "translate(77.694 1.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3156",
    "data-name": "Trazado 3156",
    d: "M375.821,22.279h-5.073a3.382,3.382,0,1,1,0,6.764h5.073a3.382,3.382,0,0,0,0-6.764Z",
    transform: "translate(-370.748 -22.279)",
    fill: "#fbb03b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-4",
    "data-name": "Path",
    transform: "translate(38.801 71.698)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3157",
    "data-name": "Trazado 3157",
    d: "M224.444,356.2H204.152l2.148-12.852a32.034,32.034,0,0,0,16,0Z",
    transform: "translate(-202.461 -341.662)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3158",
    "data-name": "Trazado 3158",
    d: "M218.563,352.014H198.271a1.691,1.691,0,0,1-1.668-1.97l2.148-12.852a1.691,1.691,0,0,1,2.09-1.359,30.427,30.427,0,0,0,15.153,0,1.691,1.691,0,0,1,2.09,1.359l2.148,12.852a1.691,1.691,0,0,1-1.668,1.97Zm-18.295-3.382h16.3l-1.523-9.113a33.85,33.85,0,0,1-13.252,0Z",
    transform: "translate(-196.58 -335.78)",
    fill: "#009f6f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-5",
    "data-name": "Path",
    transform: "translate(53.705 73.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3159",
    "data-name": "Trazado 3159",
    d: "M268.255,343.353a32.442,32.442,0,0,1-4.931.846L265.33,356.2H270.4Z",
    transform: "translate(-263.324 -343.353)",
    fill: "#fcd08c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-6",
    "data-name": "Path",
    transform: "translate(26.964 86.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3160",
    "data-name": "Trazado 3160",
    d: "M190.92,409.359v3.382a1.691,1.691,0,0,1-1.691,1.691H145.263a1.691,1.691,0,0,1-1.691-1.691v-3.382a8.455,8.455,0,0,1,8.455-8.455h30.438A8.455,8.455,0,0,1,190.92,409.359Z",
    transform: "translate(-143.572 -400.904)",
    fill: "#fcd08c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-7",
    "data-name": "Path",
    transform: "translate(60.784 86.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3161",
    "data-name": "Trazado 3161",
    d: "M300.1,400.9h-5.073a8.455,8.455,0,0,1,8.455,8.455v3.382a1.691,1.691,0,0,1-1.691,1.691h5.073a1.691,1.691,0,0,0,1.691-1.691v-3.382A8.455,8.455,0,0,0,300.1,400.9Z",
    transform: "translate(-295.023 -400.904)",
    fill: "#fbb03b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-8",
    "data-name": "Path",
    transform: "translate(1.599 18.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3162",
    "data-name": "Trazado 3162",
    d: "M59.172,146.925c-29.187-1.657-29.187-19.125-29.187-32.011V101.386A3.392,3.392,0,0,1,33.367,98H46.895v6.764H36.749v10.146c0,11.279,0,21.29,15.4,24.384h.017A31.966,31.966,0,0,0,59.172,146.925Z",
    transform: "translate(-29.985 -98.004)",
    fill: "#fbb03b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-9",
    "data-name": "Path",
    transform: "translate(18.695 59.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3163",
    "data-name": "Trazado 3163",
    d: "M106.543,282.925h.017a31.863,31.863,0,0,0,6.307,7.034c1.787.269,3.695.474,5.766.592a31.965,31.965,0,0,1-7-7.626Z",
    transform: "translate(-106.543 -282.925)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-2",
    "data-name": "Rectangle",
    transform: "translate(13.436 18.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3164",
    "data-name": "Trazado 3164",
    d: "M82.992,98h5.073v6.764H82.992Z",
    transform: "translate(-82.992 -98.004)",
    fill: "#fbb03b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-10",
    "data-name": "Path",
    transform: "translate(70.49 18.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3165",
    "data-name": "Trazado 3165",
    d: "M367.676,101.386v13.528c0,12.886,0,30.354-29.187,32.011a31.967,31.967,0,0,0,7-7.626h.017c15.4-3.095,15.4-13.105,15.4-24.384V104.768H350.766V98h13.528a3.392,3.392,0,0,1,3.382,3.382Z",
    transform: "translate(-338.489 -98.004)",
    fill: "#fbb03b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-11",
    "data-name": "Path",
    transform: "translate(70.49 18.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3166",
    "data-name": "Trazado 3166",
    d: "M364.294,98h-5.073a3.392,3.392,0,0,1,3.382,3.382v13.528c0,10.031-.011,22.836-14.149,28.951a38.275,38.275,0,0,1-9.272,2.468c-.233.195-.455.4-.693.592,29.187-1.657,29.187-19.125,29.187-32.011V101.386A3.392,3.392,0,0,0,364.294,98Z",
    transform: "translate(-338.489 -98.004)",
    fill: "#fbb03b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3167",
    "data-name": "Trazado 3167",
    d: "M119.212,31.616H107.375V24.541a5.061,5.061,0,0,0-1.691-9.835H41.426a5.061,5.061,0,0,0-1.691,9.835v7.075H27.9a5.073,5.073,0,0,0-5.073,5.073V50.217c0,12.657.012,31.745,30.316,33.665a33.725,33.725,0,0,0,10.5,5.43l-1.662,9.945H58.336A10.156,10.156,0,0,0,48.19,109.4v3.382a3.382,3.382,0,0,0,3.382,3.382H95.538a3.382,3.382,0,0,0,3.382-3.382V109.4A10.156,10.156,0,0,0,88.774,99.256H85.133l-1.662-9.945a33.725,33.725,0,0,0,10.5-5.43c30.3-1.919,30.316-21.007,30.316-33.665V36.689A5.073,5.073,0,0,0,119.212,31.616Zm-45.657,55.8A30.473,30.473,0,0,1,43.117,56.981V24.852h60.876V56.981A30.473,30.473,0,0,1,73.555,87.419ZM43.25,71.9c-10.244-3.582-10.28-11.68-10.28-21.685V41.762h6.764V56.981A33.558,33.558,0,0,0,43.25,71.9Zm64.124-14.921V41.762h6.764v8.455c0,10.006-.036,18.1-10.28,21.685A33.558,33.558,0,0,0,107.375,56.981ZM41.426,18.088h64.258a1.691,1.691,0,0,1,0,3.382H41.426a1.691,1.691,0,0,1,0-3.382ZM26.207,50.217V36.689A1.691,1.691,0,0,1,27.9,35H39.735V38.38H31.28a1.691,1.691,0,0,0-1.691,1.691V50.217c0,10.991.012,22.348,16.1,25.891a34.163,34.163,0,0,0,3.226,3.97C26.207,76.982,26.207,62.223,26.207,50.217ZM95.538,109.4v3.382H51.572V109.4a6.764,6.764,0,0,1,6.764-6.764H88.774A6.764,6.764,0,0,1,95.538,109.4ZM81.7,99.256h-16.3l1.522-9.116a33.533,33.533,0,0,0,13.251,0Zm39.2-49.039c0,12.006,0,26.765-22.712,29.861a34.162,34.162,0,0,0,3.226-3.97c16.092-3.543,16.1-14.9,16.1-25.891V40.071a1.691,1.691,0,0,0-1.691-1.691h-8.455V35h11.837a1.691,1.691,0,0,1,1.691,1.691Z",
    transform: "translate(-22.825 -14.706)",
    fill: "#344161"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrofeo);
export default __webpack_public_path__ + "static/media/trofeo.3c90be583de8a3a012319c9e30d421b5.svg";
export { ForwardRef as ReactComponent };